export default (newPath) => {
  const locationCopy = { ...window.location };
  const [, , , organizersPath, organizerId] = locationCopy.href.split("/");

  return `/${organizersPath}/${organizerId}${newPath}`;
};
